import forgotPassword from './endpoints/forgotPassword';
import getFriends from './endpoints/getFriends';
import getSharedCharts from './endpoints/getSharedCharts';
import getStudentCycleCompareSymptoms from './endpoints/getStudentCycleCompareSymptoms';
import getStudentCycleHistory from './endpoints/getStudentCycleHistory';
import login from './endpoints/login';
import setForgottenPassword from './endpoints/setForgottenPassword';
import setNotes from './endpoints/setNotes';
import setPassword from './endpoints/setPassword';

const api = {
    login,
    getFriends,
    getSharedCharts,
    setNotes,
    setPassword,
    getStudentCycleHistory,
    getStudentCycleCompareSymptoms,
    forgotPassword,
    setForgottenPassword,
};

export default api;
